<script>
import options from './DonationAmountPicker.options'
export default options
</script>

<template>
  <div :class="['kb-donation-amount-picker', `kb-donation-amount-picker--${type}`, { 'kb-donation-amount-picker--custom-amount-only': customAmountOnly }]">
    <div v-if="!customAmountOnly" class="kb-donation-amount-picker__donation-input">
      <template v-for="amount in donationAmounts" :key="amount">
        <input
          :id="`donation-amount-${amount}`"
          type="radio"
          name="donation-amount"
          autocomplete="off"
          :value="amount"
          v-model="selectedAmount"
          @change="onAmountChange"
        />
        <label :for="`donation-amount-${amount}`">{{ amount }} kr.</label>
      </template>
    </div>

    <div class="kb-donation-amount-picker__custom-donation">
      <button
        v-if="!customAmountOnly"
        id="customdonationbutton"
        class="kb-donation-amount-picker__custom-donation-button"
        type="button"
        @click="toggleCustomDonation"
      >
        {{ customDonationButtonLabel }}
      </button>

      <template v-if="customAmountOnly || customDonation">
        <div class="kb-donation-amount-picker__custom-donation-input-wrapper">
          <div class="Form__Element FormTextbox">
            <input
              v-model="customDonationAmountInput"
              aria-labelledby="otherAmountUnit customDonationAmountFormatError customDonationAmountError"
              ref="valueinputfield"
              autocomplete="off"
              type="text"
              inputmode="decimal"
              class="FormTextbox__Input"
              placeholder=""
              @blur="validateCustomDonationOnBlur"
            />
            <span id="otherAmountUnit" class="FormTextbox__Unit" :style="{ top: type === 'stafet' ? '60%' : '44%' }">kr.</span>
          </div>

          <p
            id="customDonationAmountFormatError"
            class="kb-forms Form__Element__ValidationError"
            v-if="customDonationAmountTouched && !customDonationAmountFormatIsValid"
          >
            {{ validationCustomDonationFormatLabel }}
          </p>

          <p
            id="customDonationAmountError"
            class="kb-forms Form__Element__ValidationError"
            v-if="customDonationAmountFormatIsValid && !customDonationAmountMinIsValid"
          >
            {{ validationCustomDonationAmountLabel }}
          </p>
        </div>
      </template>
    </div>

    <span
      v-if="displayInputError && errorMessage"
      class="kb-forms Form__Element__ValidationError"
    >
      {{ errorMessage }}
    </span>
  </div>
</template>
